<template>
  <div>
    <div
      class="editor-content-video__wrapper editor-wrapper"
      :class="{ editable }"
    >
      <div class="editor-content-video">
        <div v-if="src" class="editor-content-video__iframe-wrapper">
          <iframe
            v-lazy-load
            :src="src"
            width="100%"
            height="100%"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="editor-content-video__description-wrapper">
          <EditorContentEditable
            tag="span"
            class="editor-content-video__description"
            :contenteditable="editable"
            placeholder="Подпись к видео"
            :text="description"
            @blur="handleChangeDescription"
          ></EditorContentEditable>
        </div>
      </div>
      <template v-if="editable">
        <EditorContentVideoEdit
          class="content-video-edit"
          :src="src"
          @update:src="handleSrcUpdate"
          @delete="handleDelete"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
defineProps({
  editable: { type: Boolean, default: false },
  src: { type: String, default: null },
  description: { type: [String, Number], default: '' },
});

const emit = defineEmits(['update:src', 'update:description', 'delete']);

const handleChangeDescription = (e) => {
  emit('update:description', e.target.textContent);
};

const handleSrcUpdate = (src) => {
  emit('update:src', src);
};

const handleDelete = () => {
  emit('delete');
};
</script>
